module.exports = __webpack_public_path__ + "static/60fb1fa3226189748fe07f602e1c961e7a4daec0ec7835e9647bff8775009e93-ca5bdbc2eb02f70ca91b7c5c4b4e5055.jpeg";